'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Content = _antd.Layout.Content;

exports.default = function (_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(Content, {
    className: className && className
  }, _react2.default.createElement(_styled2.default.Container, null, ' ', children));
};